import { render, staticRenderFns } from "./CategoryHeatmap.vue?vue&type=template&id=235d5c34"
import script from "./CategoryHeatmap.vue?vue&type=script&lang=js"
export * from "./CategoryHeatmap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports